import * as React from 'react'
import { Text } from 'DVWebNodeUI'
import { RecordRefTag } from '../recordReftag/recordReftag'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { TrailerButton } from '../playButton/PlayButton'
import { initializePlayer } from '../../integrations/player/index'
import { PlayerConfigData } from '../../integrations/player/config'


export const TRAILER_REFTAG = 'atv_dp_watch_trailer'

export interface ITrailerProps {
  playbackData?: WpsRuntime.atv.wps.TrailerFragmentModelProps
  sessionId: string
  pageTitleId: string
  playerConfigData: PlayerConfigData
  usePlayer: boolean
}

export const Trailer = ({ playbackData, sessionId, pageTitleId, playerConfigData, usePlayer }: ITrailerProps) => {
  if (!playbackData) {
    return null
  }

  const deeplinkingData = {
    ref: TRAILER_REFTAG,
    sessionId,
    fallbackUrl: playbackData.fallbackURL,
    titleId: playbackData.playbackID,
    isTrailer: true,
    useFullView: true,
    videoType: playbackData.videoMaterialType,
    pageTitleId: pageTitleId,
  }

  const handler = (e: React.MouseEvent) => {
    const contentConfig = {
      asin: playbackData.playbackID,
      trailer: true,
      position: 0,
      ref: TRAILER_REFTAG,
      videoType: playbackData.videoMaterialType,
      useFullView: true,
    }

    initializePlayer(playerConfigData).play(contentConfig)
    e.preventDefault()
  }

  return (
    <RecordRefTag refTag={TRAILER_REFTAG} className="avu-full-width-phablet dv-dp-node-trailer">
      <TrailerButton
        onClick={usePlayer ? handler : undefined}
        forceDoubleHeight={true}
        deepLinkingData={deeplinkingData}
        href={playbackData.playbackURL}
      >
        <Text tag="span" string={playbackData.text} />
      </TrailerButton>
    </RecordRefTag>
  )
}
